import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Bell, Check } from "@phosphor-icons/react";
import { API } from "../lib/api";

export default function NotificationMenu() {
  const [notifications, setNotifications] = useState([]);
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const unread = notifications.filter((n) => !n.read).length;

  const load = () => API.get("/notifications").then((r) => setNotifications(r.data)).catch(() => {});
  useEffect(() => {
    load();
    const timer = setInterval(load, 30000);
    return () => clearInterval(timer);
  }, []);

  const markAllRead = async () => {
    await API.post("/notifications/read-all").catch(() => {});
    setNotifications((items) => items.map((n) => ({ ...n, read: true })));
  };

  return (
    <div className="relative" data-testid="guest-notification-menu">
      <button data-testid="notifications-btn" onClick={() => setOpen((value) => !value)}
        className="relative rounded-full border border-white/10 bg-black/50 p-2.5 transition-colors hover:border-neon-gold/40">
        <Bell size={20} />
        {unread > 0 && (
          <span data-testid="notification-unread-count"
            className="absolute -right-1 -top-1 flex h-5 min-w-5 items-center justify-center rounded-full bg-neon-gold px-1 text-[10px] font-black text-black shadow-glow-gold">
            {unread > 9 ? "9+" : unread}
          </span>
        )}
      </button>
      {open && (
        <div className="absolute right-0 top-12 z-40 w-80 rounded-2xl border border-white/10 bg-[#0a0a0a] p-3 shadow-2xl" data-testid="notification-dropdown">
          <div className="flex items-center justify-between px-1 pb-2">
            <span className="text-[10px] font-bold uppercase tracking-widest text-zinc-500">Notifications</span>
            <button data-testid="mark-all-read-btn" onClick={markAllRead}
              className="flex items-center gap-1 text-[10px] font-bold text-neon-gold">
              <Check size={11} /> Mark read
            </button>
          </div>
          <div className="max-h-80 space-y-2 overflow-y-auto">
            {notifications.slice(0, 10).map((n) => (
              <button key={n.id} data-testid={`notification-${n.id}`}
                onClick={() => { setOpen(false); navigate(n.url || "/app/profile"); }}
                className={`w-full rounded-xl border px-3 py-2.5 text-left ${n.read ? "border-white/5 bg-white/[0.02]" : "border-neon-gold/30 bg-neon-gold/5"}`}>
                <div className="text-xs font-black text-neon-gold">{n.title}</div>
                <div className="mt-0.5 text-xs leading-relaxed text-zinc-400">{n.body}</div>
              </button>
            ))}
            {notifications.length === 0 && <p className="py-6 text-center text-xs text-zinc-500">No notifications yet.</p>}
          </div>
        </div>
      )}
    </div>
  );
}
